export default __webpack_public_path__ + "static/media/rover base@3x.5196cad8.png";